const PHONE_REGEX = /^(1-)?\d{3}[-]\d{3}[-]\d{4}$/;
/**
 * Validates that a value is a valid phone number.
 */
export const Validator = {
    name: "phone",
    errorMessage: "Entered value is in invalid format.",
    validate: value => PHONE_REGEX.test(`${value}`),
};
